export default {
    setToken(state, payload){
        state.token=payload;
    },
    setLogin(state, payload) {
        state.loginId = payload.id;
        state.loginName = payload.name;
    },
  }